<template>
  <v-layout row wrap class="ma-1">
    <v-flex xs12 md4>
      <p v-if="!$auth.isCust()">
        {{ $tc('models.provider', 1) }}:
        <strong> {{ carrier.provider.name }} </strong>
      </p>

      <p>
        {{ $tc('models.carrier', 1) }}:
        <strong> {{ carrier.name }} </strong>
      </p>

      <p>
        {{ $tc('attrs.serviceType', 1) }}:
        <strong> {{ service.name }} </strong>
      </p>

      <p v-if="$auth.isAdmin() || $auth.isDev()">
        {{ $tc('models.user', 1) }}:
        <strong>
          {{ user.id }} /
          {{ user.name + ' ' + user.last_name }} /
          {{ user.email }}
        </strong>
      </p>
    </v-flex>

    <v-flex xs12 md4>
      <p>
        {{ $t('delcaredDimensions') }}:
        <strong>
          {{ parcel.length }} cm x {{ parcel.width }} cm x {{ parcel.height }} cm
        </strong>
      </p>
      <p>
        {{ $t('realDimensions') }}:
        <strong>
          {{ overweight.carrier_package_dimensions }} cm
        </strong>
      </p>

      <p>
        {{ $t('delcaredWeight') }}:
        <strong>
          {{ parcel.weight }} kg
        </strong>
      </p>
      <p>
        {{ $t('realWeight') }}:
        <strong>
          {{ overweight.carrier_weight }} kg
        </strong>
      </p>

      <p>
        {{ $t('declaredVolumetricWeight') }}:
        <strong>
          {{ parcel.volumetric_weight }} kg
        </strong>
      </p>
      <p>
        {{ $t('realVolumetricWeight') }}:
        <strong>
          {{ overweight.carrier_volumetric_weight }} kg
        </strong>
      </p>

    </v-flex>

    <v-flex xs12 md4 class="text-xs-right" v-if="$auth.isAdmin() || $auth.isDev()">
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: "OverweightRowComp",

  data () {
    return {
      loading: false
    }
  },

  props: {
    overweight: {
      type: Object,
      required: true
    },
  },

  components: {
  },

  computed: {
    carrier () {
      return this.service.carrier || {}
    },

    service () {
      return this.rate.service || {}
    },

    rate () {
      return this.shipment.rate || {}
    },

    parcel () {
      if (!this.shipment) { return {} }
      if (!this.shipment.parcels) { return {} }
      if (!this.shipment.parcels[0]) { return {} }

      return this.shipment.parcels[0]
    },

    user () {
      return this.shipment.user || {}
    },

    shipment () {
      return this.overweight.shipment || {}
    },
  },

  methods: {
  },

  watch: {
  },

  mounted () {
  }
}
</script>
